import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { ManpowerMetricExclusion, RepositoryModal } from '../../shared'

@Component({
    templateUrl: './manpower-outlier.component.html',
    standalone: true,
    imports: [FormsModule, FaIconComponent, WjInputModule],
})
export class ManpowerOutlierComponent extends RepositoryModal<ManpowerMetricExclusion> {
    protected onBeforeSave(): boolean {
        if (!this.target.hasExclusion && !this.target.excluded) {
            this.services.modals.warning('Exclude the job', 'Check Exclude to leave this job out of the manpower metric.')
            return false
        }

        if (this.target.excluded && !this.target.reason?.trim()) {
            this.services.modals.warning('Reason required', 'Enter a reason for excluding this job.')
            return false
        }

        if (this.target.excluded && !this.target.effectiveOn) {
            this.services.modals.warning('Effective date', 'Enter the date this exclusion starts.')
            return false
        }

        this.target.archived = !this.target.excluded
        if (!this.target.hasExclusion) {
            this.target.id = crypto.randomUUID()
            this.target.archived = false
        }

        if (!this.target.job?.trim()) {
            this.services.modals.warning('Choose a job', 'This row has no job number.')
            return false
        }

        // A new row has no creator yet. Null cannot bind to a Guid and would reject the whole save.
        const payload = this.target as Partial<ManpowerMetricExclusion>
        if (!payload.createdByUserId) {
            delete payload.createdByUserId
        }
        if (!payload.createdOn) {
            delete payload.createdOn
        }

        if (this.target.effectiveOn && !(this.target.effectiveOn instanceof Date)) {
            this.target.effectiveOn = new Date(this.target.effectiveOn)
        }

        return true
    }

    public onExcludedChanged() {
        if (this.target.excluded && !this.target.effectiveOn) {
            this.target.effectiveOn = new Date()
        }
    }

    protected onSave(resolveSave: (result?: any) => void, rejectSave: (reason?: any) => void) {
        const observable = this.target.hasExclusion ? this.repositoryEdit() : this.repositoryAdd()
        observable.subscribe({
            next: result => resolveSave(result),
            error: error => rejectSave(error),
        })
    }
}
